var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v2.33.0-dev.0-3-g69f2365fb"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import '@/server/utils/setupEnv';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: `${ENV.config.SENTRY_DSN}`,
  environment: `${ENV.stage}`,
  release: `${ENV.commitSha}`,
});
